<app-ambient-backdrop />
<app-nav-bar />

@if (working()) {
  <div class="navbar-progress" role="status" aria-label="Loading the page"><span></span></div>
}

<main [class.route-a]="routeParity() === 0" [class.route-b]="routeParity() === 1">
  <router-outlet />
</main>

<footer class="foot">
  <div class="container foot__inner">
    <div class="foot__top">
      <a routerLink="/" class="foot__brand"><app-brand-mark variant="compact" /></a>
      <p class="foot__tagline">
        Fixtures, live scores and results for the Kalaburagi Sports Habba, maintained by the
        organising committee and the scoring team.
      </p>
    </div>

    <nav class="foot__links" aria-label="Footer">
      <a routerLink="/">Home</a>
      <a routerLink="/matches">Matches</a>
      <a routerLink="/live">Live</a>
      <a routerLink="/gallery">Gallery</a>
      <a [routerLink]="isStaff() ? '/staff/dashboard' : '/staff/login'">{{ isStaff() ? 'Dashboard' : 'Staff' }}</a>
    </nav>

    <div class="foot__bottom">
      <span>&copy; {{ year }} Kalaburagi Sports Habba</span>
      <span class="foot__dot" aria-hidden="true">&middot;</span>
      <span>{{ eventDates }}</span>
      <span class="foot__dot" aria-hidden="true">&middot;</span>
      <span>Kalaburagi District Sports Complex</span>
    </div>
  </div>
</footer>

<app-confirm-dialog />

@if (busyLabel(); as label) {
  <div class="busy" role="status" aria-live="polite">
    <span class="busy__ring" aria-hidden="true"></span>
    <span class="busy__text">{{ label }}</span>
  </div>
}

@if (loadFailed()) {
  <aside class="appnote" role="alert">
    <span class="appnote__text">
      Couldn&rsquo;t load the latest tournament data. Check your connection: what you see may be out of date.
    </span>
    <button type="button" class="appnote__action" [disabled]="retrying()" (click)="retryLoad()">
      {{ retrying() ? 'Retrying…' : 'Retry' }}
    </button>
  </aside>
}
